export const FormaDescarga = Object.freeze({
    INDIVIDUAL:"INDIVIDUAL",
    MULTIPAGINA:"MULTIPAGINA"
})